import { render, staticRenderFns } from "./documentPhoto.vue?vue&type=template&id=45e2356e&scoped=true"
import script from "./documentPhoto.vue?vue&type=script&lang=js"
export * from "./documentPhoto.vue?vue&type=script&lang=js"
import style0 from "./documentPhoto.vue?vue&type=style&index=0&id=45e2356e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e2356e",
  null
  
)

export default component.exports